<template>
  <div class="tag-list">
    <ul>
      <li class="tag-search-box">
        <sis-select
          class="select"
          v-model="tags"
          :options="options"
          :multiple="true"
          :clearable="false"
          @input="removeTag"
          :max_height="135"
        />
      </li>
      <li class="tag-hint">
        {{ translate('tag.hint') }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TagSelect',
  model: {
    prop: 'taglist',
    event: 'input'
  },
  props: {
    taglist: {
      type: Array
    },
    options: {
      type: Array
    },
  },
  data () {
    return {
      tags: [...this.taglist],
      tag: '',
      len_tag: 0
    }
  },
  watch: {
    taglist () {
      this.tags = [...this.taglist]
    }
  },
  methods: {
    removeTag () {
      this.$emit('input', [...this.tags])
    }
  }

}

</script>
<style lang="scss">
.tag-list {
  border: 1px solid #DCDCDC;
  margin: 10px;
  padding: 10px;
  height: 100%;
}
  .tag-list ul > * {
    display: inline-block;
  }
.tag {
  margin: 2px 3px;
  padding: 2px 4px 3px 6px;
  border-radius: 5px;
  font-size: 1.35rem;
  line-height: 1.75rem;
  background-color: #41B883;
  color: #fff;
}
.tag-search-box {
    margin: 0 !important;
    .form-control{
      height: 42px;
    }
}
.tag-hint {
    font-size: 1rem;
    line-height: 1.25rem;
    color: #b0adab;
    margin: 1rem 0 0;
    display: block !important;
}
  .tag .delete-btn {
       width: 14px;
       height: 14px;
       padding: 1px 0 0 1px;
       margin: 0;
       color: #ffffffa1;
       border: 1px solid #ffffffa1;
       border-radius: 25%;
       background: none;
       font-size: 8px;
       line-height: 12px;
  }
</style>
